import { UIData } from '../../hooks/stores/uiStore';
import { LauncherStatesData } from '../../hooks/stores/launcherStatesStore';
import { stateViewsInfo } from '../../info/stateViewsInfo';

interface CommandUtilsDependencies {
  UIData: UIData;
  setUIData: (data: Partial<UIData> | ((prev: UIData) => Partial<UIData>)) => void;
  setLauncherStatesData: (data: LauncherStatesData) => void;
  setLauncherView: (view: keyof typeof stateViewsInfo) => void;
}

export interface Command {
  type: string;
  appProcessExtraArgsAsText?: string;
  linkUrl?: string;
  popupId?: string;
}

export function createCommandUtils({
  UIData,
  setUIData,
  setLauncherStatesData,
  setLauncherView,
}: CommandUtilsDependencies) {
  const executeCommand = (command: Command) => {
    switch (command.type) {
      case 'minimizeWindowCommand':
        break;
      case 'hideWindowCommand':
        break;
      case 'maximizeOrRestoreWindowCommand':
        break;

      case 'startAppInstallTaskCommand':
        setLauncherView('stateViewInstallationInProgress');
        break;
      case 'cancelAppInstallTaskCommand':
        setLauncherView('stateViewNotInstalled');
        break;
      case 'pauseAppInstallTaskCommand':
        setLauncherView('stateViewInstallationPaused');
        break;
      case 'resumeAppInstallTaskCommand':
        setLauncherView('stateViewInstallationInProgress');
        break;
      case 'chooseAppPathCommand':
        // TODO: show path dialog
        // setLauncherView('stateViewMoveInProgress');
        break;
      case 'startAppCommand':
        setLauncherView('stateViewRunning');
        break;
      case 'startAppUninstallTaskCommand':
        setLauncherView('stateViewUninstallationInProgress');
        break;
      case 'startAppUpdateTaskCommand':
        setLauncherView('stateViewUpdateInProgress');
        break;
      case 'pauseAppUpdateTaskCommand':
        setLauncherView('stateViewUpdatePaused');
        break;
      case 'resumeAppUpdateTaskCommand':
        setLauncherView('stateViewUpdateInProgress');
        break;
      case 'startAppRepairTaskCommand':
        setLauncherView('stateViewRepairInProgress');
        break;
      case 'pauseAppRepairTaskCommand':
        setLauncherView('stateViewRepairPaused');
        break;
      case 'resumeAppRepairTaskCommand':
        setLauncherView('stateViewRepairInProgress');
        break;

      case 'openExternalLinkCommand':
        window.open(command.linkUrl, '_blank');
        break;

      case 'openPopupCommand':
        if (!command.popupId) return;
        if (UIData.openPopupIDs.includes(command.popupId)) return;

        setUIData((prev: UIData) => ({
          ...prev,
          openPopupIDs: [...prev.openPopupIDs, command.popupId!]
        }));
        break;

      case 'closePopupCommand':
        if (!command.popupId) return;

        setUIData((prev: UIData) => ({
          ...prev,
          openPopupIDs: prev.openPopupIDs.filter((id: string) => id !== command.popupId)
        }));
        break;

      case 'togglePopupCommand':
        if (!command.popupId) return;

        if (UIData.openPopupIDs.includes(command.popupId)) {
          executeCommand({
            type: 'closePopupCommand',
            popupId: command.popupId,
          });
        } else {
          executeCommand({
            type: 'openPopupCommand',
            popupId: command.popupId,
          });
        }
        break;
    }
  };

  return {
    executeCommand,
  };
} 